import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function SocialPreview() {
  return <div style={{
    width: 1200,
    height: 630,
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Inter', sans-serif"
  }} className="bg-charcoal-950" data-id="element-230">
      {/* Background image — action shot */}
      <img src="https://cdn.magicpatterns.com/uploads/nBbWR557z149baLXUu2DRm/94-IMG_5381.jpg" alt="" style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      filter: 'brightness(0.45)'
    }} data-id="element-231" />

      {/* Dark gradient overlay for text legibility */}
      <div style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.6) 50%, rgba(10,10,10,0.85) 100%)'
    }} data-id="element-232" />

      {/* Amber accent bar on left */}
      <div style={{
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 12,
      background: '#d4a853'
    }} data-id="element-233" />

      {/* Content */}
      <div style={{
      position: 'relative',
      zIndex: 10,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '0 80px',
      color: '#f5f5f0'
    }} data-id="element-234">
        {/* Eyebrow */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 24
      }} data-id="element-235">
          <div style={{
          width: 40,
          height: 4,
          background: '#d4a853',
          borderRadius: 2
        }} data-id="element-236" />
          <span style={{
          fontSize: 18,
          fontWeight: 600,
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: '#d4a853'
        }} data-id="element-237">
            McLean Physical Therapy
          </span>
        </div>

        {/* Main headline */}
        <h1 style={{
        fontSize: 88,
        fontWeight: 800,
        lineHeight: 1.05,
        letterSpacing: '-0.02em',
        margin: 0,
        marginBottom: 28,
        maxWidth: 900
      }} data-id="element-238">
          Where Recovery Meets{' '}
          <span style={{
          color: '#d4a853'
        }} data-id="element-239">
            Performance
          </span>
        </h1>

        {/* Subtitle */}
        <p style={{
        fontSize: 26,
        lineHeight: 1.4,
        color: '#e8e8e0',
        margin: 0,
        marginBottom: 40,
        maxWidth: 820,
        fontWeight: 400
      }} data-id="element-240">
          Modern physical therapy and performance coaching — combining in-person
          care with personalized programming.
        </p>

        {/* Footer row */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        color: '#d4a853',
        fontSize: 22,
        fontWeight: 600
      }} data-id="element-241">
          <MapPinIcon size={24} data-id="element-242" />
          <span data-id="element-243">Camarillo, CA · Serving Ventura County</span>
        </div>
      </div>
    </div>;
}